// extracted by mini-css-extract-plugin
module.exports = {"albumLinks":"album-links-module--albumLinks--1Kkzo"};